import React, { useMemo } from "react";
import removeIllegalChars from "../../util/removeIllegalChars";
import LightTheme from "../theme/LightTheme";

interface Props {
  name: string;
}

const DefaultAvatar = ({ name }: Props) => {
  const initials = useMemo(
    () =>
      name
        .split(" ")
        .map((word) => removeIllegalChars(word)[0])
        .join("")
        .toUpperCase(),
    [name],
  );

  return (
    <div>
      <p>{initials}</p>
      <style jsx>{`
        div {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background: ${LightTheme.gradientBackground};
          display: flex;
          align-items: center;
          justify-content: center;
        }
        p {
          font-size: 20px;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default DefaultAvatar;
